// @flow
import type {JSONFont} from "./jsontypes.js";
import { hasWOFF2Support } from "../environment";

let _supportedFontFmts: string[] | undefined = undefined;

export default class Font {
	name: string = "";
	style: string = "";
	weight: string = "";
	variants: string[] = [];

	constructor(url: string, json: JSONFont) {
		this.name = json.id;
		this.style = json.style;
		this.weight = json.weight;

		this.variants = ["woff"];
		if (json.woff2) {
			this.variants.push("woff2");
		}

		const expectedExtension = "." + this.variants[0];
	  	const isExpected = url.endsWith(expectedExtension);
  
	  	this.baseUrl = isExpected
			? url.substring(0, url.length - expectedExtension.length)
			: url
		;
  
		if (!isExpected) {
			this.variants = [];
	  	}
	}

	get url(): string {
		if (undefined === _supportedFontFmts) {
			_supportedFontFmts = {
				woff: true,
				woff2: hasWOFF2Support,
			};
		}

		if (this._cachedUrl) {
			return this._cachedUrl;
		}

		let foundUrl = this.baseUrl;

		// we assume that font variants are reverse-ordered by desirability
		const variants = this.variants.slice().reverse();
		for (const fmt of variants) {
			if (_supportedFontFmts[fmt]) {
				foundUrl = `${this.baseUrl}.${fmt}`;
				break;
			}
		}

		this._cachedUrl = foundUrl;

		return foundUrl;
	}
}



// WEBPACK FOOTER //
// ./lib/api/font.js